import { Div, Flex } from '@sendoutcards/quantum-design-ui'
import { useState } from 'src/hooks'

type FilterMode = 'eq' | 'lte' | 'gte'
type FilterValue = { [key in FilterMode]?: string }

type SmartDateFilterProps = {
  onChange: (value: FilterValue) => void
}

const SmartDateFilter = ({ onChange }: SmartDateFilterProps) => {
  const [mode, setMode] = useState<FilterMode | undefined>(undefined)
  const [date, setDate] = useState<string>('')
  const [hovered, setHovered] = useState<FilterMode | null>(null)

  const handleUpdate = (newDate: string, newMode: FilterMode) => {
    setDate(newDate)
    if (newMode) {
      onChange({ [newMode]: newDate })
    }
  }

  return (
    <Flex style={{ alignItems: 'center', gap: '8px' }}>
      <input
        type="date"
        value={date}
        onChange={e => {
          const newDate = e.target.value
          setDate(newDate)
          if (mode) {
            onChange({ [mode]: newDate })
          }
        }}
        style={{
          border: '1px solid #ccc',
          borderRadius: '4px',
          padding: '4px 8px',
          fontSize: '13px',
          fontWeight: 500,
          fontFamily: '"Montserrat", sans-serif',
          overflow: 'hidden',
        }}
      />
      <Div
        style={{
          display: 'flex',
          gap: '0',

          overflow: 'visible',
        }}
      >
        {(['eq', 'lte', 'gte'] as FilterMode[]).map(m => {
          const isSelected = mode === m
          const isDisabled = !date
          const showTooltip = isDisabled && hovered === m

          return (
            <div
              key={m}
              style={{
                position: 'relative',
                display: 'flex',
                justifyContent: 'center',
                borderRadius: '6px',

                alignItems: 'center',
                borderRight:
                  m !== 'gte' && !isSelected
                    ? '1px solid #ccc'
                    : isSelected
                      ? 'none'
                      : 'none',
              }}
              onMouseEnter={() => setHovered(m)}
              onMouseLeave={() => setHovered(null)}
            >
              <button
                onClick={() => {
                  if (isDisabled) return
                  setMode(m)
                  handleUpdate(date, m)
                }}
                style={{
                  padding: '4px 8px',
                  backgroundColor: isSelected ? '#404040' : '#fff',
                  color:
                    isDisabled && !isSelected
                      ? '#b3b3b3'
                      : isSelected
                        ? '#fff'
                        : '#333',
                  border: 'none',
                  borderRadius: isSelected ? '4px' : 'none',

                  cursor: showTooltip ? 'not-allowed' : 'pointer',
                  fontSize: '13px',
                  fontWeight: 500,
                  fontFamily: '"Montserrat", sans-serif',
                  transition: 'all 0.2s ease',
                  opacity: isDisabled && !isSelected ? 0.6 : 1,
                }}
              >
                {m === 'eq' ? 'On' : m === 'lte' ? 'Before' : 'After'}
              </button>
              {showTooltip && (
                <Div
                  style={{
                    position: 'absolute',
                    top: '-22px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    backgroundColor: '#333',
                    color: '#fff',
                    padding: '2px 6px',
                    fontSize: '12px',
                    fontFamily: '"Montserrat", sans-serif',
                    borderRadius: '4px',
                    whiteSpace: 'nowrap',
                    zIndex: 10,
                    pointerEvents: 'none',
                  }}
                >
                  Enter a date
                </Div>
              )}
            </div>
          )
        })}
      </Div>
    </Flex>
  )
}

export default SmartDateFilter
